<template>
  <section class="orders">
    <main class="mx-2">
      <h4 class="ml-3">{{ $route.path == '/clients' ? 'All Clients' : 'Cold Call Clients'  }}</h4>
      <div class="row px-1 mx-0 ">
        <div class="col-12 px-0 mx-0 py-0 my-0" v-if="hasPermissions('adminClients')">
          <div class="card p-2">

            <div class="w-100">
              <div class="float-left">
                <div v-if="isUserOliverSale || hasPermissions('superAdmin')">
                  <span v-if="userOliverSales.length <= 1"
                    class="loadingres spinner-border loading-spinner ml-2 pb-1"></span>
                  <div class="col-3 px-0 ml-0 mb-2" v-else>
                    <IndustrySearch :option_list="userOliverSales" :default_values="userOliverSale" :key="key"
                      :multiple="false" @selected="selectOliverSale" />
                  </div>
                </div>

                <div class="float-left">
                  <FilterSystem class="float-left" :columns="campaignsColumns" :reset="resetFilterSystem" :sort="sort"
                    :dir="dir" :filterSystem="filtersSystem" :filterOldQuery="oldQuery" :key="filterkey"
                    @callApi="filterNow($event)" />
                </div>
              </div>

              <div id="neworder" class="float-right">
                <button class="w-100 btn btn-sm btn-primary themed-button effect-btn" @click="showModalCreateAccount"
                  type="submit">
                  <i class="icon-plus1"></i>
                  {{ $t("lang.button.new_client") }}
                </button>
              </div>
            </div>


          </div>
        </div>
        <!-- End Button New Client -->
        <div class="w-100">
          <div class="my-2">
            <Tabs :tabs="tabs" :disabled="loading" @change="changeTab($event)" :tabSelected="tabSelected" />
          </div>

          <div id="actionsSearch" class="float-left" v-if="!loading && agencies.list.length > 0">
            <small>
              {{ $t("lang.label.results") }}:
              <small v-if="!total" class="ml-1 text-primary">{{ $t("lang.search.calculating") }}...</small>
              <strong v-else>{{ total }}</strong>
            </small>
            <div></div>
          </div>
          <div class="float-right">
            <button class="
                btn btn-sm btn-primary
                themed-button
                effect-btn
                float-left
                mb-2
              " v-if="simpleversion && !hasPermissions('isReferal')" @click="showAll">
              {{ $t('lang.button.advancedview') }}
              <i class="icon-eye"></i>
            </button>

            <button v-if="this.model.fullstats != true" class="ml-3
                btn btn-sm btn-primary
                themed-button
                effect-btn
                float-left
                mb-2
              " @click="withStadistic">
              View with statistics
              <i class="icon-eye"></i>
            </button>
          </div>
        </div>
        <div class="col-12 card">

          <LoadingSpinner v-if="loading" />
          <div class="mx-0 px-0" :class="$route.path == '/clients' ? 'table-responsive' : 'table-sticky'"
            v-if="!loading && agencies.list.length > 0 && simpleversion">
            <Table class="mx-2 w-100" :key="keyresult" :headers="simpleheader" :cols="simplecols" :data="agencies.list" :checkbox="false"
              :notselect="true" :model="model" @goToAgency="goToAgency" @sendToCrm="sendToCrm"
              @orderBy="orderBy($event)">
            </Table>
          </div>
          <div
            v-if="!loading && agencies.list.length > 0 && !simpleversion && $store.state.authentication.user.role_id == 1">
            <span class="badge badge-success text-white">sent</span>
            <span class="badge badge-primary text-white ml-1">scheduled</span>
            <span class="badge badge-warning text-white ml-1">estimated</span>
            <span class="badge badge-secondary text-white ml-1">canceled</span>
            <span class="badge badge-danger text-white ml-1">bounced</span>
          </div>
          <div class="mx-0 px-0" :class="$route.path == '/clients' ? 'table-responsive' : 'table-sticky'" v-if="!loading && agencies.list.length > 0 && !simpleversion">
            <Table class="mx-2 w-100" :key="keyresult" :headers="headers" :cols="cols" :data="agencies.list" :checkbox="false"
              :notselect="true" :model="model" @goToAgency="goToAgency" @sendToCrm="sendToCrm">
            </Table>
          </div>
          <div v-if="!loading && agencies.list.length == 0">
            <div class="text-center w-100 mt-4">
              <div class="alert alert-warning" role="alert">
                {{ $t("lang.label.noresults") }}
              </div>
            </div>
            <div class="text-center w-100 mt-4">
              <img src="@/assets/images/search-oliver3.png" class="rounded mx-auto d-block" width="200px" />
            </div>
          </div>
        </div>
        <div class="my-3">
          <Pagination v-if="!loading" :total="total" :totalpage="agencies.list.length" :model="model" color="primary"
            :limit="true" @changePage="changePage" :key="paginationkey"></Pagination>
        </div>

        <section></section>
      </div>
      </div>
    </main>

    <!-- Create account -->
    <Modal :name="'createAccount'" height="95%" width="60%">
      <AccountCreationFirst :user="getUser" :calledFromAdmin="true" @closeModal="cloaseModalCreateAcccount()" />
    </Modal>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Table from "@/components/Common/Table.vue";
import Tabs from "@/components/Common/Tabs.vue";
import Pagination from "@/components/Common/Pagination.vue";
import { router } from "@/_helpers";
import { statusPointMixin, billingUtilsMixin } from "@/_mixins/";
import { clientsService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import moment from "moment";
import FilterSystem from "@/components/FilterSystem.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import AccountCreationFirst from "@/components/AccountCreation/Steps/AccountCreationFirst.vue";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import { usersService } from "@/_services";

export default {
  data() {
    return {
      key: 232332,
      oliver_sale_id: '0',
      userOliverSale: ["0"],
      userOliverSales: [{ id: "0", label: "All" }],
      requestDataWihtoutFilter: false,
      filteredList: false,
      tabSelected: 1,
      campaignsColumns: [
        {
          name: this.$t("lang.label.companyname"),
          name_: "client",
          type: "string",
          field: "cl.name",
        },
        {
          name: this.$t("lang.column.email"),
          name_: "email",
          type: "string",
          field: "cl.email",
        },
        {
          name: 'Total Meetings',
          name_: "client1",
          type: "number",
          field: "clstats.total_meetings",
        },
        {
          name: 'Total conversion rate',
          name_: "conversion_rate",
          type: "number",
          field: "clstats.meeting_rate",
        },
        {
          name: 'Lifetime',
          name_: "life_time",
          type: "number",
          field: "life_time",
          having: true,
        },
        {
          name: 'Total average new contact / day',
          name_: "average",
          type: "number",
          field: "clstats.total_contacts_day",
        },
        {
          name: 'Current month Total Meetings',
          name_: "current",
          type: "number",
          field: "clstats.total_meetings_this_month",
        },
        {
          name: 'Current month average new contact / day',
          name_: "current",
          type: "number",
          field: "clstats.total_contacts_day_this_month",
        },
        {
          name: 'Current month conversion rate',
          name_: "current",
          type: "number",
          field: "clstats.meeting_rate_this_month",
        },
        {
          name: 'Creation date',
          name_: "create_date",
          type: "date",
          field: "cl.creation_date",
        },
        {
          name: this.$t("lang.onBoarding.commercial_in_charge"),
          name_: "oliver_sale",
          type: "string",
          field: "CONCAT(u3.lastname, ', ', u3.name)",
        },
        {
          name: 'Warning available contact',
          name_: "available_contact",
          type: "list",
          list: [
            { id: true, name: this.$t("lang.button.yes") },
            { id: false, name: this.$t("lang.label.no") },
          ],
          field: "clstats.available_contacts_warning",
        },
        {
          name: 'Warning 404',
          name_: "404",
          type: "list",
          list: [
            { id: true, name: this.$t("lang.button.yes") },
            { id: false, name: this.$t("lang.label.no") },
          ],
          field: "clstats.landing_config_warning",
        },
        {
          name: 'Warning landing config',
          name_: "landing_config_warning",
          type: "list",
          list: [
            { id: true, name: this.$t("lang.button.yes") },
            { id: false, name: this.$t("lang.label.no") },
          ],
          field: "clstats.landing_page_creation_warning",
        },
        {
          name: 'Warning non prospecting emails',
          name_: "prospecting_emails_warning",
          type: "list",
          list: [
            { id: true, name: this.$t("lang.button.yes") },
            { id: false, name: this.$t("lang.label.no") },
          ],
          field: "clstats.prospecting_emails_warning",
        },
        {
          name: 'Warning Credit card expiration',
          name_: "credit_card_warning",
          type: "list",
          having: true,
          list: [
            { id: true, name: this.$t("lang.button.yes") },
            { id: false, name: this.$t("lang.label.no") },
          ],
          field: "credit_card_warning",
        },
        {
          name: 'Warning payment declined',
          name_: "payment_declined_warning_days",
          type: "list",
          list: [
            { id: true, name: this.$t("lang.button.yes") },
            { id: false, name: this.$t("lang.label.no") },
          ],
          field: "p.id",
        },
        {
          name: 'Warning billing config',
          name_: "billing_config_warning",
          type: "list",
          list: [
            { id: true, name: this.$t("lang.button.yes") },
            { id: false, name: this.$t("lang.label.no") },
          ],
          field: "clstats.billing_config_warning",
        },
        {
          name: 'Warning calendar link https',
          name_: "calendar_https_warning",
          type: "list",
          list: [
            { id: true, name: this.$t("lang.button.yes") },
            { id: false, name: this.$t("lang.label.no") },
          ],
          field: "clstats.calendar_https_warning",
        },
        {
          name: 'Warning lower cashable margin',
          name_: "lower_cashable_margin_warning",
          type: "list",
          list: [
            { id: true, name: this.$t("lang.button.yes") },
            { id: false, name: this.$t("lang.label.no") },
          ],
          field: "lower_cashable_margin_warning",
        },
      ],
      simpleversion: true,
      tabs: {
        1: {
          id: 1,
          name: this.$t("lang.label.all"),
        },
        // 2: {
        //   id: 2,
        //   name: this.$t("lang.label.createteamaccount"),
        //   clientStatusId: 1,
        //   icon: "icon-user",
        // },
        2: {
          id: 2,
          name: "Onboarding",
          clientStatusId: [1, 2],
          icon: "icon-list",
        },
        3: {
          id: 3,
          name: this.$t("lang.label.validating"),
          clientStatusId: [9],
          icon: "icon-wrench",
        },
        4: {
          id: 4,
          name: this.$t("lang.targets.active"),
          clientStatusId: 3,
          icon: "icon-clock",
        },
        5: {
          id: 5,
          name: this.$t("lang.appointments.active"),
          clientStatusId: 4,
          icon: "icon-play",
        },
        6: {
          id: 6,
          name: this.$t("lang.appointments.standby"),
          clientStatusId: 5,
          icon: "icon-pause",
        },
        7: {
          id: 7,
          name: this.$t("lang.label.pendingdeleted"),
          clientStatusId: 8,
          icon: "icon-remove",
        },
        8: {
          id: 8,
          name: this.$t("lang.payment.Canceled"),
          clientStatusId: 7,
          icon: "icon-refresh",
        },
        9: {
          id: 9,
          name: this.$t("lang.label.deleted"),
          clientStatusId: 6,
          icon: "icon-remove",
        },
      },
      tabSelected: 5,
      total: 0,
      keyresult: 0,
      paginationkey: 0,
      model: {},
      loading: false,
      lastfilter: false,
      currentPage: 1,
      filterkey: 2233,
      cantPerPage: 50,
      cantPerPageOptions: [5, 10, 20, 50, 100],
      searchFilter: {},
      quickSearchFilter: "",
      selected: [],
      allSelected: false,
      campaignIds: [],
      opened: [],
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        minDate: moment().startOf("day"),
      },
      resetFilterSystem: false,
      agencies: {},
      sort: "",
      dir: "",
      simpleheader_max: [
        {
          label: this.$t("lang.label.statistics6m"),
          class: "overflowhide",
          id: 25,
        },
        {
          label: this.$t("lang.label.statistics_month_30d"),
          class: "overflowhide",
          id: 26,
        },
      ],
      simpleheader: [
        {
          label: this.$t("lang.column.status"),
          class: "overflowhide",
        },
        // {
        //   label: this.$t("lang.label.actions"),
        //   class: "overflowhide",
        //   role_id: 1
        // },
        {
          label: 'Client name',
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.affiliated_to"),
          class: "overflowhide",
        },
        {
          label: 'CPI',
          class: "overflowhide",
        },
        {
          label: 'Account Manager',
          class: "overflowhide",
        },
        {
          label: 'Account Executive',
          class: "overflowhide",
        },
        // {
        //   label: 'Last status update',
        //   class: "overflowhide",
        // },
        // {
        //   label: 'Last status days',
        //   class: "overflowhide",
        // },
        {
          label: this.$t("lang.label.subscription"),
          class: "overflowhide",
          id: 7,
        },
        {
          label: this.$t("lang.label.billing"),
          class: "overflowhide",
          id: 8,
        },
        {
          label: this.$t("lang.appointments.signedon"),
          class: "overflowhide",
          id: 10,
        },
        {
          label: "Lifetime",
          class: "overflowhide",
          id: 11,
        },
        // {
        //   label: "Warnings",
        //   class: "overflowhide",
        // },

      ],
      headers: [
        // {
        //   label: "Meeting Rate",
        //   class: "overflowhide",
        //   id:1,
        // },
        {
          label: this.$t("lang.column.status"),
          class: "overflowhide",
          id: 2,
        },
        {
          label: this.$t("lang.column.client"),
          class: "overflowhide",
          id: 3,
        },
        {
          label: this.$t("lang.label.affiliated_to"),
          class: "overflowhide",
          id: 4,
        },
        {
          label: "CPI",
          class: "overflowhide",
          id: 9,
        },
        {
          label: "Subscription",
          class: "overflowhide",
          id: 7,
        },
        {
          label: this.$t("lang.appointments.signedon"),
          class: "overflowhide",
          id: 10,
        },
        {
          label: this.$t("lang.label.statistics6m"),
          class: "overflowhide",
          id: 25,
        },
        {
          label: this.$t("lang.label.statistics_month_30d"),
          class: "overflowhide",
          id: 26,
        },
        {
          label: 'Warnings',
          class: "overflowhide",
          id: 27,
        },
        {
          label: this.$t("lang.label.activity"),
          class: "overflowhide",
          role_id: 1
        },
      ],
      simplecols: [
        [
          {
            label: this.$t("lang.label.createteamaccount"),
            value: "client_status_id",
            value_if: 1,
            type: "condition",
          },
          {
            label: "Onboarding",
            value: "client_status_id",
            value_if: 2,
            type: "condition",
          },
          {
            label: this.$t("lang.targets.active"),
            value: "client_status_id",
            value_if: 3,
            type: "condition",
          },
          {
            label: this.$t("lang.appointments.active"),
            value: "client_status_id",
            value_if: 4,
            type: "condition",
          },
          {
            label: this.$t("lang.appointments.standby"),
            value: "client_status_id",
            value_if: 5,
            type: "condition",
          },
          {
            label: this.$t("lang.label.deleted"),
            value: "client_status_id",
            value_if: 6,
            type: "condition",
          },
          {
            label: this.$t("lang.payment.Canceled"),
            value: "client_status_id",
            value_if: 7,
            type: "condition",
          },
          {
            label: this.$t("lang.label.pendingdeleted"),
            value: "client_status_id",
            value_if: 8,
            type: "condition",
          },
          {
            label: this.$t("lang.label.validating"),
            value: "client_status_id",
            value_if: 9,
            type: "condition",
          },
        ],
        // [
        //   {
        //     label: "Send to Crm",
        //     value_emit: "id",
        //     class: "btn btn-sm btn-primary",
        //     type: "emit",
        //     emit: "sendToCrm",
        //     role_id: 1
        //   },
        // ],
        [
          {
            value_label: "client_name",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "goToAgency",
          },
        ],
        [
          {
            value: "affiliation_client_name",
          }
        ],
        [
          {
            value: "cpi_category",
            value2: "cpi_score_formatted",
            type: "itemBadge",
            class: "badge badge-pill text-small",
            colors: [
              { id: "Strategic", label: "Strategic", bgColor: "#28a745", textColor: "#FFFFFF" },
              { id: "Core", label: "Core", bgColor: "#007bff", textColor: "#FFFFFF" },
              { id: "Watch", label: "Watch", bgColor: "#fd7e14", textColor: "#FFFFFF" },
              { id: "Low Priority", label: "Low Priority", bgColor: "#6c757d", textColor: "#FFFFFF" },
              { id: "Launching", label: "Launching", bgColor: "#6f42c1", textColor: "#FFFFFF" },
              { id: "-", label: "-", bgColor: "#e9ecef", textColor: "#6c757d" },
            ],
          },
        ],
        [
          {
            value: "oliver_sale",
            class: "text-primary",
          },
        ],
        [
          {
            value: "account_executive_name",
            class: "text-primary",
          },
        ],
        // [
        //   {
        //     value: "last_status_update",
        //     class: "text-primary",
        //   },
        // ],
        // [
        //   {
        //     value: "last_status_days",
        //     class: "text-primary",
        //   },
        // ],
        [
          {
            value: "subscription_data",
            class: "text-primary",
          },
        ],
        [
          {
            value: "billing_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "1",
                icon_true:
                  "icon-minus-circle text-danger icon-small",
                tooltip_true: "DISABLED",
              },
              {
                icon_if_value: "2",
                icon_true:
                  "icon-clock text-warning icon-small",
                tooltip_true: "UNTIL TARGET RUNNING",
              },
              {
                icon_if_value: "4",
                icon_true:
                  "icon-clock text-warning icon-small",
                tooltip_true: "UNTIL KICKOFF + 30 DAYS",
              },
              {
                icon_if_value: "3",
                icon_true:
                  "icon-checkmark text-sucess icon-small",
                tooltip_true: "Active",
              },
            ],
          }
        ],
        [
          {
            value: "signed_on",
            class: "text-primary",
            filter: "formatDate",
          },
        ],
        [
          {
            value: "life_time",
            class: "text-primary",
          },
        ],

        //[
        //   {
        //     value: "warnings",
        //     type: "listBadges",
        //     class: "text-primary",
        //   },
        // ],
        // [
        //   {
        //     value: "signature_expiration_date",
        //     class: "text-primary",
        //     filter: "formatDate",
        //   },
        // ],
        // [
        //   {
        //     value: "signed_on",
        //     class: "text-primary",
        //     filter: "formatDate",
        //   },
        // ],
        // [
        //   {
        //     value: "creation_date",
        //     class: "text-primary",
        //   },
        // ],
      ],
      cols: [
        // [
        //   {
        //     value: "meeting_rate",
        //     class: "text-primary",
        //   },
        // ],
        [
          {
            value: "client_status",
            class: "text-primary",
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "goToAgency",
          },
        ],
        [
          {
            value: "affiliation_client_name"
          }
        ],
        [
          {
            value: "cpi_category",
            value2: "cpi_score_formatted",
            type: "itemBadge",
            class: "badge badge-pill text-small",
            colors: [
              { id: "Strategic", label: "Strategic", bgColor: "#28a745", textColor: "#FFFFFF" },
              { id: "Core", label: "Core", bgColor: "#007bff", textColor: "#FFFFFF" },
              { id: "Watch", label: "Watch", bgColor: "#fd7e14", textColor: "#FFFFFF" },
              { id: "Low Priority", label: "Low Priority", bgColor: "#6c757d", textColor: "#FFFFFF" },
              { id: "-", label: "-", bgColor: "#e9ecef", textColor: "#6c757d" },
            ],
          },
        ],
        [
          {
            value: "subscription_data",
            class: "text-primary",
          },
        ],
        [
          {
            value: "signed_on",
            class: "text-primary",
            filter: "formatDate",
          },
        ],
        [
          {
            value: "statistics6m",
            type: "listBadges",
            class: "text-primary",
          },
        ],
        [
          {
            value: "statistics_month_30d",
            type: "listBadges",
            class: "text-primary",
          },
        ],
        [
          {
            value: "warnings",
            type: "listBadges",
            class: "text-primary",
          },
        ],
        [
          {
            value: "id",
            type: "clientActivity",
            loading: "true",
            role_id: 1
          }
        ],
      ],
    };
  },

  mixins: [statusPointMixin, billingUtilsMixin],

  props: {
    filter: Object,
    user: Object,
    clientSubscriptions: {
      type: Number,
      default: 0
    }
  },

  components: {
    LoadingSpinner,
    FilterSystem,
    Tooltip,
    Table,
    Pagination,
    Tabs,
    AccountCreationFirst,
    IndustrySearch
  },
  mounted() {
    this.setHeader();
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      headerTab: (state) => state.header.tab,
      oldQuery: (state) => state.campaigns.oldQuery,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),

    getUser() {
      return this.$store.state.authentication.user;
    },
    isUserOliverSale() {
      return (this.currentUser.role_id == 1 && this.currentUser.user_constraint_id == 2);
    },
  },
  created() {
    if (this.clientSubscriptions == '5') {

      this.simpleheader = this.simpleheader.filter( //Saque columnas pedidas de vista subscription
        h => h.id !== 7 && h.id !== 11 &&
          h.label !== this.$t("lang.label.affiliated_to") &&
          h.label !== 'CPI' &&
          h.label !== 'Account Executive'
      )

      this.simplecols = this.simplecols.filter( //En conjunto con los datos que conllevaban
        col => col[0].value !== "subscription_data" && col[0].value !== "life_time" &&
          col[0].value !== "affiliation_client_name" &&
          col[0].value !== "cpi_category" &&
          col[0].value !== "account_executive_name"
      )

      this.cantPerPage = 100
      this.simpleheader.push(
        {
          label: "Consigne",
          class: "overflowhide",
        },
        {
          label: "Cold task pending",
          class: "overflowhide",
        },
        {
          label: "Cold meeting rate",
          class: "overflowhide",
        },
        {
          label: "Cold tasks done",
          class: "overflowhide",
        },
        {
          label: "Cold tasks done today",
          class: "overflowhide",
        },
        {
          label: "Running orders",
          class: "overflowhide",
        },
        {
          label: "Pickups rate",
          class: "overflowhide",
        },
        {
          label: "Avg meeting price",
          class: "overflowhide",
        },
        {
          label: "Bookers",
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.dedicated_bookers"),
          class: "overflowhide",
          id: 11,
        },
        {
          label: "Subscription price",
          class: "overflowhide",
        },
        {
          label: "Booker Price",
          class: "overflowhide",
        },
        {
          label: "LTV",
          class: "overflowhide",
        },
      )
      this.simplecols.push(
        [
          {
            value: "booking_signal_type",
            type: "badgeBookingSignal",
            labelField: "booking_signal_badge_label",
            tooltipField: "booking_signal_tooltip",
          },
        ],
        [
          {
            value: "total_task_todo",
            // type: "isAsync"
          }
        ],
        [
          {
            value: "cold_meeting_rate",
            class: "text-primary",
            format: "percentage",
            // type: "isAsync"
          },
        ],
        [
          {
            value: "cold_tasks_done",
            class: "text-primary",
            // type: "isAsync"
          },
        ],
        [
          {
            value: "cold_tasks_done_today",
            type: "itemBadgeConditional",
            min: "cold_tasks_done_today_min",
          },
        ],
        [
          {
            value: "running_orders",
            class: "text-primary",
            type: "isAsync"
          }
        ],        
        [
          {
            value: "pickup_rate",
            class: "text-primary",
            type: "isAsync"
          },
        ],   
        [
          {
            value: "avg_meeting_rate",
            class: "text-primary",
            type: "isAsync"
          }
        ],  
        [
          {
            value: "id",
            type: "imageSetMultipleLines",
            from: "client",
            client_priority_value: "priority",
          },
        ],        
        [
          {
            value: "dedicated_bookers",
            class: "text-primary",
          }
        ],
        [
          {
            value: "subscription_price_formatted",
            class: "text-primary",
          }
        ],
        [
          {
            value: "subscription_booker_price_formatted",
            class: "text-primary",
          }
        ],
        [
          {
            value: "ltv_amount_formatted",
            class: "text-primary",
          }
        ]
      )
    }
    if (this.isUserOliverSale) {
      this.oliver_sale_id = this.currentUser.id
      this.init('created', this.oliver_sale_id)
      this.model.oliver_sale = this.currentUser.id
    } else {
      this.init('created')
    }
    if (this.model.cantPerPage == undefined) {
      this.model.currentPage = 1;
      this.model.cantPerPage = this.cantPerPage;
    }

    /*if (!this.simpleversion) {
      this.model.getcomplete = true;
    } else {*/
    this.model.getcomplete = true;
    //}

    this.initTabsForRoute();
    if (this.$route.path === '/clients') {
      this.filterByClientStatusId(5, [4, 7, 8]);
    } else {
      this.filterByClientStatusId(5, 4);
    }

    //Hide columsn 'calendar_availabilities', 'group_missing' to user No SuperAdmin
    if (!this.hasPermissions('superAdmin')) {
      const hideHeaders = [15, 16]
      this.headers = this.headers.filter(header => !hideHeaders.includes(header.id))

      const hideColumns = ['calendar_availabilities', 'group_missing']
      this.cols = this.cols.filter(col => !hideColumns.includes(col[0].if_value))
    }
  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),

    init(origin, userOliverSaleId) {
      if (origin == 'created') {
        this.getUserOliverSales()
      }
    },

    applyBookingSignalFields(item) {
      const type = item.booking_signal_type;
      const typeLabels = {
        boost: 'BOOST',
        reduce: 'RÉDUIRE',
        stop: 'STOP',
      };
      const typeTitles = {
        boost: 'PRIORITÉ RÉSULTATS',
        reduce: 'RÉDUIRE LE VOLUME',
        stop: 'STOP BOOKING',
      };

      if (!type || !typeLabels[type] || !item.booking_signal_valid_until) {
        item.booking_signal_type = null;
        item.booking_signal_badge_label = null;
        item.booking_signal_tooltip = null;
        return;
      }

      const shortDate = this.formatBookingSignalDate(item.booking_signal_valid_until, true);
      const fullUntil = this.formatBookingSignalDate(item.booking_signal_valid_until, false);
      const posedOn = this.formatBookingSignalDate(item.booking_signal_created, false);
      const author = item.booking_signal_author_name || 'AM';
      const message = item.booking_signal_message || '';

      item.booking_signal_badge_label = `${typeLabels[type]} - ${shortDate}`;
      item.booking_signal_tooltip = [
        typeTitles[type] || typeLabels[type],
        message,
        `Author: ${author}`,
        `posée le ${posedOn}`,
        `valable jusqu'au ${fullUntil}`,
      ]
        .filter(Boolean)
        .join(' - ');
    },

    formatBookingSignalDate(value, short) {
      if (!value) return '—';
      const raw = String(value).substring(0, 10);
      const parts = raw.split('-');
      if (parts.length !== 3) return raw;
      if (short) return `${parts[2]}/${parts[1]}`;
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    },

    getUserOliverSales() {
      usersService.getUserOliverSales(true, 0 , true)
        .then(res => {
          if (res.result.length > 0) {
            const userOliverSalesWithlabel = res.result.map(el => ({ ...el, label: el.lastname + ", " + el.name }))
            this.userOliverSales.push(...userOliverSalesWithlabel)
            this.oliverSalesLoaded = true
            this.userOliverSales.map((it) => {
              if (it.id == this.$store.state.authentication.user.id) {
                this.userOliverSaleId = it.id
                this.userOliverSale = [it.id.toString()]

              }
            })
            this.key++
          }
        })
        .catch(err => console.error(err))
    },


    selectOliverSale(value) {
      this.oliver_sale_id = value.id
      const userOliverSaleId = value.id
      this.userOliverSale[0] = parseInt(value.id)

      if (userOliverSaleId != this.previewUserOliverSale) {
        this.init(null, userOliverSaleId);
        this.previewUserOliverSale = userOliverSaleId
      }

      if (this.userOliverSale[0] == '0') {
        this.model.oliver_sale = undefined
      } else {
        this.model.oliver_sale = value.id
      }
      this.loading = true;
      this.searchAgenciesSimple();
      this.search();

    },

    cloaseModalCreateAcccount() {
      this.$modal.hide("createAccount");
      this.searchAgencies();
    },

    showModalCreateAccount() {
      this.$modal.show("createAccount");
    },
    changeTab(id) {
      this.tabSelected = id;
      this.model.currentPage = 1;
      this.filterByClientStatusId(id, this.tabs[id].clientStatusId);
    },
    hasPermissions(perm) {
      return this.$store.getters['authentication/hasPermissions'](perm)
    },
    withStadistic() {

      this.loading = true;
      let meetingCols = [
        [
          {
            value: "statistics",
            type: "listBadges",
            class: "text-primary",
          },
        ],
        [
          {
            value: "statistics_month",
            type: "listBadges",
            class: "text-primary",
          },
        ],
      ];
      console.log(this.model)
      this.model.fullstats = true
      this.simplecols = this.simplecols.concat(meetingCols);
      this.simpleheader = this.simpleheader.concat(this.simpleheader_max);

      this.searchAgenciesSimple()
      this.keyresult++;
    },
    orderBy(event) {
      let order = "";
      order = `${event.field} ${event.order} `;
      this.model.order = order;
      this.searchAgencies();
      this.simpleheader.forEach((item) => {
        if (item.field == event.field) {
          if (item.order == "ASC") {
            item.order = "DESC";
          } else {
            item.order = "ASC";
          }
        }
      });
    },
    filterNow(filters) {
      this.filteredList = true;
      this.loading = true;
      this.searchFilter = filters;
      this.model.searchFilter = this.searchFilter;
      this.searchAgenciesSimple();
      this.search();
    },
    changePage() {
      this.loading = true;
      if (this.model.searchFilter) {
        this.searchAgenciesSimple();
      } else {
        this.searchAgencies();
      }
      //this.searchAgencies();
    },
    processResponse(response) {
      response.list.forEach((item) => {
        // set domain_config_ready

        // if (item.warning_campaign_creation == "1") {
        //   item.warning_campaign_creation == "0";
        // }

        // if (item.warning_campaign_launching > 0) {
        //   item.campaigns_launching = "2";
        // } else {
        //   item.campaigns_launching = "1";
        // }

        if (item.target_config == null) {
          item.target_config = "0";
        }

        // CPI: normalize category for itemBadge and format score for "(0.82)" display
        const category = item.cpi_category || (item.cpi_score != null ? this.cpiCategoryFromScore(Number(item.cpi_score)) : null);
        item.cpi_category = category || '-';
        item.cpi_score_formatted = item.cpi_score != null ? Number(item.cpi_score).toFixed(2) : '';

        // Subscription / booker price / LTV (same formatting as ClientSubscribers)
        item.subscription_price_formatted = item.subscription_price
          ? `€ ${parseFloat(item.subscription_price).toFixed(2)}`
          : '€ 0.00';
        const bookerPrice =
          item.subscription_booker_price != null && item.subscription_booker_price !== ''
            ? `€ ${parseFloat(item.subscription_booker_price).toFixed(2)}`
            : '€ 0.00';
        item.subscription_booker_price_formatted =
          item.dedicated_bookers == '0' || item.dedicated_bookers == 0 ? '€ 0.00' : bookerPrice;
        item.ltv_amount_formatted =
          item.ltv_amount != null && item.ltv_amount !== ''
            ? `€ ${parseFloat(item.ltv_amount).toFixed(2)}`
            : '€ 0.00';

        this.applyBookingSignalFields(item);

        if (this.clientSubscriptions == '5') {
          item.cold_tasks_done_today = 'empty';
        }

        //  showLandingConfigWarning = false;
        if (item.signed_on == null) {
          item.team_config = null;
        } else {
          // if (item.workspace_domain_not_config) {
          //   //si tiene uno NO comprado
          //   item.domain_config_ready = "1";
          // } else {
          //   if (item.workspace_domain_config) {
          //     //si tiene comprado
          //     item.domain_config_ready = "2";
          //   } else {
          //     item.domain_config_ready = "0"; //si no tiene nada
          //   }
          // }
          /*
          if (item.workspace_user_config == 0) {
            if (item.team_config == 1) {
              item.team_config = null;
            }
          }
          if (item.billing_config == null) {
            item.billing_config = 2;
          }
          const signedOn = new Date(item.signed_on).getTime();
          const rightNow = new Date().getTime().toFixed(0);
          const days = ((rightNow - signedOn) / 1000 / 60 / 60 / 24).toFixed(
            0
          );

          if (days > 5) {
            showLandingConfigWarning = true;
          }
          */
        }

        /*  item.landing_config_ready = showLandingConfigWarning
            ? this.getConfigIsReady(item.landing_config)
            : null;*/

        // Only when the option view advance is selected
        if (this.model.getcomplete) {
          const {
            total_meetings,
            total_contacts_day,
            total_email_sent,
            total_amount,
            total_email_sent_this_month,
            total_amount_current_month,
            meeting_rate,
            total_meetings_this_month,
            total_contacts_day_this_month,
            meeting_rate_this_month,
            calendar_sync_warning,
            calendar_sync_warning_days,
            calendar_https_warning,
            calendar_https_warning_days,
            billing_config_warning,
            billing_config_warning_days,
            credit_card,
            credit_card_warning,
            credit_card_warning_days,
            payment_declined,
            payment_declined_warning,
            payment_declined_warning_days,
            calendar_availabilities_warning,
            calendar_availabilities_warning_days,
            prospecting_emails_warning_days,
            prospecting_emails_warning,
            available_contacts_warning_days,
            available_contacts_warning,
            landing_page_creation_warning_days,
            landing_page_creation_warning,
            landing_config_warning_days,
            landing_config_warning,
            calendar_nylas_warning_days,
            calendar_nylas_warning,
            lower_cashable_margin_warning
          } = item;

          const listItemsTotals = [
            {
              label: this.$t("lang.column.avg_new_contact_day_short"),
              value: (total_contacts_day) ? total_contacts_day : '0',
              class: 'badge badge-success text-light',
              link: null,
              icon: "icon_sent-mail2.png",
              tooltip: "Average new contact engaged / day",
            },
            {
              label: this.$t("lang.column.avg_new_contact_day_short"),
              value: (total_email_sent) ? total_email_sent : '0',
              class: 'badge badge-success text-light',
              link: null,
              icon: "icon_sent-mail.png",
              tooltip: "Sent emails",
            },
            {
              label: this.$t("lang.column.conversion_rate_short"),
              value: (meeting_rate) ? meeting_rate : '0',
              class: 'badge badge-success text-light',
              link: null,
              icon: "icon_bar-chart.png",
              tooltip: "Meetings / Unique prospects",
            },
            {
              label: this.$t("lang.column.total_meetings_short"),
              value: (total_meetings) ? total_meetings : '0',
              class: 'badge badge-success text-light',
              link: null,
              icon: "icon_agenda.png",
              tooltip: "Meetings",
            },
            // {
            //   label: this.$t("lang.column.total_meetings_short"),
            //   value: (total_amount) ? total_amount : '0',
            //   class: 'badge badge-success text-light',
            //   link: null,
            //   icon: "icon_coin.png",
            //   tooltip: "Meetings",
            // },
          ];
          item.statistics = listItemsTotals;

          const listItemsTotalsByMonth = [
            {
              label: this.$t("lang.column.avg_new_contact_day_this_month_short"),
              value: (total_contacts_day_this_month) ? total_contacts_day_this_month : '0',
              class: 'badge badge-success text-light',
              link: null,
              icon: "icon_sent-mail2.png",
              tooltip: "Average new contact engaged / day",
            },
            {
              label: this.$t("lang.column.avg_new_contact_day_short"),
              value: (total_email_sent_this_month) ? total_email_sent_this_month : '0',
              class: 'badge badge-success text-light',
              link: null,
              icon: "icon_sent-mail.png",
              tooltip: "Sent emails",
            },
            {
              label: this.$t("lang.column.conversion_rate_this_month_short"),
              value: (meeting_rate_this_month) ? meeting_rate_this_month : '0',
              class: (meeting_rate_this_month < 0.35) ? 'badge badge-danger' : 'badge badge-success text-light',
              link: null,
              icon: "icon_bar-chart.png",
              tooltip: "Meetings / Unique prospects",
            },
            {
              label: this.$t("lang.column.total_meetings_this_month_short"),
              value: (total_meetings_this_month) ? total_meetings_this_month : '0',
              class: 'badge badge-success text-light',
              link: null,
              icon: "icon_agenda.png",
              tooltip: "Meetings",
            },
            //{
            //   label: this.$t("lang.column.total_meetings_short"),
            //   value: (total_amount_current_month) ? total_amount_current_month : '0',
            //   class: 'badge badge-success text-light',
            //   link: null,
            //   icon: "icon_coin.png",
            //   tooltip: "Meetings",
            // },
          ];

          item.statistics_month = listItemsTotalsByMonth;

          let listItemsWarnings = [];

          if (item.calendar_nylas === '1' && false) {
            listItemsWarnings.push(
              {
                label: 'Calendar Sync',
                value: calendar_nylas_warning_days,
                class: 'badge badge-danger text-light',
                link: null,
                icon: "icon_calendar.png",
                tooltip: calendar_nylas_warning,
              }
            )
          }

          if (item.billing_config === '2') {
            listItemsWarnings.push(
              {
                label: 'Payment Profile',
                value: billing_config_warning_days,
                class: 'badge badge-primary text-light',
                link: null,
                icon: "icon_credit-card.png",
                tooltip: billing_config_warning,
              }
            )
          }

          if (item.credit_card === '2') {
            listItemsWarnings.push(
              {
                label: 'Credit Card',
                value: credit_card_warning_days,
                class: 'badge badge-primary text-light',
                link: null,
                icon: "icon_credit-card-expired.png",
                tooltip: credit_card_warning
              }
            )
          }

          if (item.payment_declined === '2') {
            listItemsWarnings.push(
              {
                label: 'Credit Card',
                value: payment_declined_warning_days,
                class: 'badge badge-primary text-light',
                link: null,
                icon: "icon_payment-declined.png",
                tooltip: payment_declined_warning
              }
            )
          }

          if (item.calendar_https === '2') {
            listItemsWarnings.push(
              {
                label: 'Calendar HHTTPS',
                value: calendar_https_warning_days,
                class: 'badge badge-primary text-light',
                link: null,
                icon: "icon_https.png",
                tooltip: calendar_https_warning,
              }
            )
          }

          if (item.calendar_availabilities === '2') {
            listItemsWarnings.push(
              {
                label: 'Availability',
                value: calendar_availabilities_warning_days,
                class: 'badge badge-warning text-light',
                link: null,
                icon: "icon_calendar.png",
                tooltip: calendar_availabilities_warning,
              }
            )
          }

          if (item.prospecting_emails === '2') {
            listItemsWarnings.push(
              {
                label: 'Emails sending',
                value: prospecting_emails_warning_days,
                class: 'badge badge-info text-light',
                link: null,
                icon: "icon_email.png",
                tooltip: prospecting_emails_warning,
              }
            )
          }

          if (item.available_contacts === '2') {
            listItemsWarnings.push(
              {
                label: 'Low Leads',
                value: available_contacts_warning_days,
                class: 'badge badge-success text-light',
                link: null,
                icon: "icon_group.png",
                tooltip: available_contacts_warning,
              }
            )
          }

          if (item.landing_page_creation === '2') {
            listItemsWarnings.push(
              {
                label: 'Landing Page creation',
                value: landing_page_creation_warning_days,
                class: 'badge badge-danger text-light',
                link: null,
                icon: "icon_web.png",
                tooltip: landing_page_creation_warning,
              }
            )
          }

          if (item.lower_cashable_margin_warning) {
            listItemsWarnings.push(
              {
                label: 'Lower cashable margin',
                value: lower_cashable_margin_warning,
                class: 'badge badge-danger text-light',
                link: null,
                icon: "lost.png",
                tooltip: 'Lower cashable margin',
              }
            )
          }

          // if( item.landing_config === '2'){
          //   listItemsWarnings.push(
          //     {
          //       label: 'Landing 404 error',
          //       value: landing_config_warning_days,
          //       class: 'badge badge-danger text-light',
          //       link: null,
          //       icon: "icon_404.png",
          //       tooltip: landing_config_warning,
          //     }
          //   )
          // }

          item.warnings = listItemsWarnings
        }

      });
    },
    sendToCrm(id) {
      clientsService.sendToCrm(id)
    },
    searchAgencies() {

      this.model.clientSubscriptions = this.clientSubscriptions

      clientsService.searchAgencies(this.model).then((response) => {
        if (!this.model.searchFilter) {
          this.processResponse(response);
          this.agencies = response;
          this.loading = false;
          this.keyresult++;

          const clients = response.list.map(client => client.id);
          
          if(this.clientSubscriptions != 0){
            this.getAdditionalData(clients);
          }          
        }
      });
    },
    getAdditionalData(clients) {
      clientsService.getColdMeetingRate(clients)
        .then((response) => {

          this.agencies.list.forEach((client) => {

            const cold_tasks_done_today = response.result.find(el => el.type == "cold_tasks_done_today" && el.client_id == client.id)

            if (cold_tasks_done_today) {
              client.cold_tasks_done_today = Number(cold_tasks_done_today.total).toFixed(0);
            } else {
              client.cold_tasks_done_today = "0"
            }
            client.cold_tasks_done_today_min = 70;

            const pickup_rate =  response.result.find(el => el.type == "pickup_rate" && el.client_id == client.id )

            if(pickup_rate){
              client.pickup_rate = Number(pickup_rate.total).toFixed(2);
            } else {
              client.pickup_rate = "0"
            }  

            const running_orders =  response.result.find(el => el.type == "running_orders" && el.client_id == client.id )

            if(running_orders){
              client.running_orders = Number(running_orders.total).toFixed(0);
            } else {
              client.running_orders = "0"
            }  

            const avg_meeting_rate =  response.result.find(el => el.type == "avg_meeting_rate" && el.client_id == client.id )

            if(avg_meeting_rate){
              client.avg_meeting_rate = Number(avg_meeting_rate.total).toFixed(0);
            } else {
              client.avg_meeting_rate = "0"
            } 

          });

        });   
    },

    searchAgenciesSimple() {
      clientsService.searchAgencies(this.model).then((response) => {
        this.processResponse(response);
        this.agencies = response;
        this.loading = false;
        this.keyresult++;
      });
    },
    showAll() {
      this.model.getcomplete = true;
      this.simpleversion = false;
      this.search();
    },
    getConfigIsReady(configs) {
      if (configs == null) {
        return 2;
      }
      return 1;
    },
    setHeader() {
      if(this.$route.path == '/clients'){
        this.setCurrentRoute({ page: "clients", label: "All Clients" });
        this.setCurrentRouteChild({ child: "" });
      }else if(this.$route.path == '/client-subscriptions'){
        this.setCurrentRoute({ page: "client-subscriptions", label: "Cold Call Clients" });
        this.setCurrentRouteChild({ child: "" });
      }else if(this.$route.path == '/client-stats'){
        this.setCurrentRoute({ page: "client-stats", label: "Client Stats" });
        this.setCurrentRouteChild({ child: "" });
      }
    },
    getClass(step, campaign) {
      var savedSteps;

      savedSteps = campaign.step;

      if (step == 2) {
        if (campaign.total_contacts > 0) {
          return "text-success";
        }
        return "text-secondary";
      }

      if (savedSteps == null) return "text-secondary";

      if (
        savedSteps.indexOf(step) >= 0 ||
        savedSteps.indexOf(step.toString()) >= 0
      ) {
        return "text-success";
      }
      if (savedSteps == null) return "text-secondary";

      if (
        (savedSteps.indexOf(1) >= 0 || savedSteps.indexOf("1") >= 0) &&
        (savedSteps.indexOf(3) >= 0 || savedSteps.indexOf("3") >= 0) &&
        (savedSteps.indexOf(4) >= 0 || savedSteps.indexOf("4") >= 0) &&
        (savedSteps.indexOf(5) >= 0 || savedSteps.indexOf("5") >= 0)
      ) {
        return "text-success";
      }
      return "text-secondary";
    },

    showEmptyImage() {
      return this.agencies.list.length == 0;
    },

    filterByClientStatusId(tabId, clientStatusId) {
      this.tabSelected = tabId;
      this.model.clientStatusId = clientStatusId;
      this.search();
    },

    initTabsForRoute() {
      if (this.$route.path !== '/clients') {
        return;
      }
      this.model.recoveryByMailbox = true;
      this.$set(this.tabs[5], 'clientStatusId', [4, 7, 8]);
      this.$delete(this.tabs, 7);
      this.$delete(this.tabs, 8);
    },

    cpiCategoryFromScore(score) {      
      if (score >= 0.25) return 'Strategic';
      if (score >= 0.20) return 'Core';
      if (score >= 0.15) return 'Watch';
      return 'Low Priority';
    },
    goToAgency(client_id, client_name) {
      //(client_id, this.hasPermissions('isAgencyManager'), this.$store.state.authentication.user.role_id);
      if (!this.hasPermissions('isAgencyManager') || this.hasPermissions('adminAgency')) {
        let url = "/clients/" + client_id;
        window.open(url, "_blank");
      }
    },
    search() {
      this.changePage();
      clientsService.searchAgenciesTotal(this.model).then((response) => {
        if (response !== undefined) {
          this.total = parseInt(response.total);
        }
      });
    },
    getPercentage(fraction, total) {
      if (total == 0) {
        return "-%";
      } else {
        var result = (fraction / total) * 100;
        result = parseFloat(result).toFixed(0);
        return result + "%";
      }
    },
  },
};
</script>
